
import InputTextForm from "base/InputTextForm"
import InputNumberForm from "base/InputNumberForm"
import InputCalendarForm from "base/InputCalendarForm"
import InputTextareaForm from "./InputTextareaForm"
import InputSwitchForm from "./InputSwitchForm"
import InputDropdownForm from "./InputDropdownForm"
import InputDropdown2Form from "./InputDropdown2Form"
import { Controller } from "react-hook-form"
import InputAutoCompleteForm from "./InputAutoCompleteForm"
import InputPasswordForm from "./InputPasswordForm"
import InputAutoCompleteMultipleForm from "./InputAutoCompleteMultipleForm"
import InputTriStateCheckboxForm from "./InputTriStateCheckboxForm"
import InputTriStateButtonsForm from "./InputTriStateButtonsForm"
import InputTriStateCheckboxSimpleForm from "./InputTriStateCheckboxSimpleForm"

export default function ControllerInput(props) {

    const form = props.form
    const rules = props.rules || { required: false }
    let className = props.className

    if (props.className) {
        className = props.className
    } else if (props.addClassName) {
        className = "field col-12 mb-2 " + props.addClassName
    }

    return (
        <div className={className} >
            <Controller
                name={props.field}
                defaultValue={''} // Alterei de null para '', atentar-se para possíveis problemas!
                control={form.control}
                rules={rules}
                render={(controller) => {

                    if (props.type === 'text') {
                        return <InputTextForm form={form} controller={controller} {...props} />
                    } else if (props.type === 'tristatecheckbox') {
                        return <InputTriStateCheckboxForm form={form} controller={controller} {...props} />
                    } else if (props.type === 'tristatecheckboxsimple') {
                        return <InputTriStateCheckboxSimpleForm form={form} controller={controller} {...props} hiddenLabel={true} />
                    } else if (props.type === 'tristatebuttons') {
                        return <InputTriStateButtonsForm form={form} controller={controller} {...props} />
                    } else if (props.type === 'number') {
                        return <InputNumberForm form={form} controller={controller} {...props} />
                    } else if (props.type === 'calendar') {
                        return <InputCalendarForm form={form} controller={controller} {...props} />
                    } else if (props.type === 'textarea') {
                        return <InputTextareaForm form={form} controller={controller} {...props} />
                    } else if (props.type === 'switch') {
                        return <InputSwitchForm form={form} controller={controller} {...props} />
                    } else if (props.type === 'dropdown') {
                        return <InputDropdownForm form={form} controller={controller} {...props} />
                    } else if (props.type === 'dropdown2') {
                        return <InputDropdown2Form form={form} controller={controller} {...props} />
                    } else if (props.type === 'autocomplete') {
                        return <InputAutoCompleteForm form={form} controller={controller} {...props} />
                    } else if (props.type === 'autocompletemultiple') {
                        return <InputAutoCompleteMultipleForm form={form} controller={controller} {...props} />
                    } else if (props.type === 'password') {
                        return <InputPasswordForm form={form} controller={controller} {...props} />
                    }

                    return <></>
                }}
            />
        </div >
    )
}